import { BuilderElement, BuilderContent } from '@builder.io/sdk';

/*
  This is needed, as we are now wrapping all components in Section components,
  so we have to then recursivly check children to find other components.

  This is a recursive function that flattens the blocks and their children, filtered by the component name.
*/
export const getAllBlocksWithComponentName = (
  content: BuilderContent | undefined,
  componentName: string
): BuilderElement[] => {
  if (!content) {
    return [];
  }

  const getAllBlocksRecursively = (blocks: BuilderElement[]): BuilderElement[] => {
    return blocks.flatMap((block) => [block, ...(block.children ? getAllBlocksRecursively(block.children) : [])]);
  };

  const allBlocks = content?.data?.blocks ?? [];
  const flattened = getAllBlocksRecursively(allBlocks);

  return flattened.filter((block) => block.component?.name === componentName);
};

/*
  Removes blocks with a specific component name from Builder content.
  Returns a new content object with the blocks filtered out (does not mutate original).
*/
export const removeBlocksByComponentName = (
  content: BuilderContent | undefined,
  componentName: string
): BuilderContent | undefined => {
  if (!content?.data?.blocks) {
    return content;
  }

  const filterBlocksRecursively = (blocks: BuilderElement[]): BuilderElement[] => {
    return blocks
      .filter((block) => block.component?.name !== componentName)
      .map((block) => ({
        ...block,
        children: block.children ? filterBlocksRecursively(block.children) : undefined,
      }));
  };

  return {
    ...content,
    data: {
      ...content.data,
      blocks: filterBlocksRecursively(content.data.blocks),
    },
  };
};
